import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Footer from "../../component/Footer";
import NavBar from "../../component/Navbar";
import Sidebar from "../../component/Sidebar";
import CustomSpin from "../../component/Spin/CustomSpin";
import { SpinProvider } from "../../component/Spin/spin.context";
import helper from "../../helper/helper";
import CustomerRequests from "./customer-request/screen/CustomerRequests";
import EditCustomerRequest from "./customer-request/screen/EditCustomerRequest";
import Customers from "./customer/screen/Customers";
import EditCustomer from "./customer/screen/EditCustomer";
import Documents from "./document/screen/Documents";
import EditDocument from "./document/screen/EditDocument";
import ErrorPage from "./error/screen/ErrorPage";
import EditPlan from "./plan/screen/EditPlan";
import Plans from "./plan/screen/Plans";
import UploadCustomerPlan from "./plan/screen/UploadCustomerPlan";
import EditProduct from "./product/screen/EditProduct";
import Products from "./product/screen/Products";
import EditPromotion from "./promotion/screen/EditPromotion";
import Promotions from "./promotion/screen/Promotions";
import Assignments from "./task/screen/Assignments";
import EditAssignment from "./task/screen/EditAssignment";
import EditTask from "./task/screen/EditTask";
import Tasks from "./task/screen/Tasks";
import { RouteProvider } from "./user/screen/components/route.context";
import EditUser from "./user/screen/EditUser";
import Users from "./user/screen/Users";
import { useEffect } from "react";
import Brands from "./brand/screen/Brands";
import EditBrand from "./brand/screen/EditBrand";
import Categories from "./category/screen/Categories";
import EditCategory from "./category/screen/EditCategory";

const PrivateRoutes = () => {
  useEffect(() => {
    (window as any).App.initBeforeLoad();
    (window as any).App.initCore();
    (window as any).App.initAfterLoad();
  }, []);

  return (
    <RouteProvider>
      <NavBar />
      <div className="page-content">
        <Sidebar />
        <div className="content-wrapper">
          <SpinProvider>
            <CustomSpin>
              {helper.isLogged() ? (
                <Routes>
                  <Route path="/" element={<Navigate to="/users" />} />
                  <Route path="/users/add" element={<EditUser />} />
                  <Route path="/users" element={<Users />} />
                  <Route path="/users/:userId" element={<EditUser />} />
                  <Route path="/customers" element={<Customers />} />
                  <Route
                    path="/customers/:customerId"
                    element={<EditCustomer />}
                  />
                  <Route path="/brand" element={<Brands />} />
                  <Route path="/brand/add" element={<EditBrand />} />
                  <Route path="/brand/:brandId" element={<EditBrand />} />
                  <Route path="/category" element={<Categories />} />
                  <Route path="/category/add" element={<EditCategory />} />
                  <Route
                    path="/category/:categoryId"
                    element={<EditCategory />}
                  />
                  <Route path="/products" element={<Products />} />
                  <Route
                    path="/products/:productId"
                    element={<EditProduct />}
                  />
                  <Route path="/plans" element={<Plans />} />
                  <Route path="/plans/add" element={<EditPlan />} />
                  <Route
                    path="/plans/customer/add"
                    element={<UploadCustomerPlan />}
                  />
                  <Route path="/plans/:planId" element={<EditPlan />} />
                  <Route path="/tasks" element={<Tasks />} />
                  <Route path="/assignments" element={<Assignments />} />
                  <Route
                    path="/assignments/:assignmentId"
                    element={<EditAssignment />}
                  />
                  <Route path="/assignments/add" element={<EditAssignment />} />
                  <Route path="/tasks/:taskId" element={<EditTask />} />
                  <Route path="/promotions" element={<Promotions />} />
                  <Route
                    path="/customer/requests"
                    element={<CustomerRequests />}
                  />
                  <Route
                    path="/customer/requests/:customerRequestId"
                    element={<EditCustomerRequest />}
                  />
                  <Route path="/promotions/add" element={<EditPromotion />} />
                  <Route path="/documents" element={<Documents />} />
                  <Route
                    path="/documents/:documentId"
                    element={<EditDocument />}
                  />
                  <Route path="/documents/add" element={<EditDocument />} />
                  <Route
                    path="/promotions/:promotionId"
                    element={<EditPromotion />}
                  />
                  <Route path="*" element={<ErrorPage />} />
                </Routes>
              ) : (
                <Navigate to="/auth/login" />
              )}
            </CustomSpin>
          </SpinProvider>
          <Footer />
        </div>
      </div>
    </RouteProvider>
  );
};

export default PrivateRoutes;
